import type { UiColor } from 'tokens';
import * as S from './styles';

interface ChipProps {
	label: string;
	color?: UiColor;
	className?: string;
}

const Chip = ({ label, color = 'gray', className }: ChipProps) => {
	return (
		<S.Base $color={color} className={className}>
			{label}
		</S.Base>
	);
};

export default Chip;
